<template>
    <div id="app">
        <router-view/>
    </div>
</template>


<script>

    export default {
        name: "app",
        // created() {
        //     //在页面加载时读取sessionStorage里的状态信息
        //     if (sessionStorage.getItem("store")) {
        //         this.$store.replaceState(Object.assign({},
        //             this.$store.state,
        //             JSON.parse(sessionStorage.getItem("store"))
        //         ))
        //         sessionStorage.removeItem('store');
        //     }
        //     //在页面刷新时将vuex里的信息保存到sessionStorage里
        //     window.addEventListener("beforeunload", () => {
        //         sessionStorage.setItem("store", JSON.stringify(this.$store.state))
        //     })
        // },
    };
</script>
<style>
    .el-pagination {
        position: relative;
        float: right;
        margin-right: 3%;
        margin-top: 30px;
        margin-bottom: 50px;
    }
</style>
<style scoped>

    #app {
        min-width: 1280px;
       
    }
</style>
